import md5 from 'js-md5'

function isTokenValid(token, dateToken){

    if(token == null || dateToken==null){
        return false;
    }

    var horaActual = new Date().getTime();
    var difMils = horaActual - dateToken;
    var secs = difMils/1000;
    
    //60 secs *60*7  = 7 horas
    if(secs>(60*60*7)){
        return false;
    }
    return true;
}

const tokenLife = 60*4;//60 secs * 4  = 4 minutos
function isTokenContribuyenteValid(token, dateToken){

    if(token == null || dateToken==null){
        return false;
    }

    var horaActual = new Date().getTime();
    var difMils = horaActual - dateToken;
    var secs = difMils/1000;
    
    if(secs>tokenLife){
        return false;
    }
    return true;
}

function md5Malformed(pass){
    var digest=md5.digest(pass+"jaja");
    var hex = '';
    for (const idx in digest) {
        hex = hex + digest[idx].toString(16);
    }
    return hex;
}

export {isTokenValid, md5Malformed, isTokenContribuyenteValid};